document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("[allow-transparency-new]");
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle("is-scroll-less100", window.scrollY < 100);
  };

  window.addEventListener("scroll", onScroll, { passive: true });

  onScroll(); // run once on load
});